/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * CALCLIST.jsonの1件分のデータ
 * @export
 * @interface CalcListItem
 */
export interface CalcListItem {
    /**
     * ファイル名
     * @type {string}
     * @memberof CalcListItem
     */
    fileName: string;
    /**
     * タイトル
     * @type {string}
     * @memberof CalcListItem
     */
    title: string;
    /**
     * 説明
     * @type {string}
     * @memberof CalcListItem
     */
    description: string;
    /**
     * 対象時刻
     * @type {string}
     * @memberof CalcListItem
     */
    tgttime?: string;
}

/**
 * Check if a given object implements the CalcListItem interface.
 */
export function instanceOfCalcListItem(value: object): value is CalcListItem {
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function CalcListItemFromJSON(json: any): CalcListItem {
    return CalcListItemFromJSONTyped(json, false);
}

export function CalcListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalcListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'title': json['title'],
        'description': json['description'],
        'tgttime': json['tgttime'] == null ? undefined : json['tgttime'],
    };
}

export function CalcListItemToJSON(json: any): CalcListItem {
    return CalcListItemToJSONTyped(json, false);
}

export function CalcListItemToJSONTyped(value?: CalcListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileName': value['fileName'],
        'title': value['title'],
        'description': value['description'],
        'tgttime': value['tgttime'],
    };
}

